module.exports = __webpack_public_path__ + "img/area_of_opportunity.66268e3d.png";